<template>
  <div class="main-content">
    <MENU></MENU>
  </div>
</template>

<script>
import MENU from './menu'
export default {
  components: {
    MENU
  },

  created() {

  },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {
  }

};
</script>
